document.addEventListener("DOMContentLoaded", () => {
    new Swiper(".rooms-section .swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1440: {
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
    });

   let containers = document.querySelectorAll('.rooms-container');
   if( containers ){
    containers.forEach(container=>{
        let item = container.querySelector('.room-option');
        if( item ){
            item.click();
        }
    })
   }


});

